// @flow
import React from 'react';

export const MainHelp = [
  {
    question:'¿En qué consiste la aplicación?',
    response() {
      return (
        <p>
          Es un proceso de screening en el que evaluamos tu perfil, te preguntamos algunos datos para saber
          más acerca de ti, como por ejemplo: grado de escolaridad, empleo, ingresos,etc.
          Así como información de las personas con las que vas a vivir.
        </p>
      );
    }
  },
  {
    question:'¿Qué necesitas para realizar tu aplicación?',
    response() {
      return (
        <p>
          Los documentos que te solicitamos son una identificación oficial y comprobantes de ingresos de los
          últimos tres meses (recibos de nómina o estados bancarios de tu cuenta de débito).
          En menos de 24 horas te damos respuesta. Homie garantiza que todos tus datos están protegidos.
        </p>
      );
    }
  },
  {
    question:'¿Vas a dividir el monto de tu renta con alguien?',
    response() {
      return (
        <p>
          También necesitaremos documentos de las personas con las que vas a compartir la renta.
        </p>
      );
    }
  },
  {
    question: '¿Eres persona Moral?',
    response() {
      return (
        <p>
          Los documentos que te solicitamos son Identificación oficial del representante legal,
          Acta constitutiva de la empresa así como la última declaración anual de la empresa.
        </p>
      );
    }
  }
];
